import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { providerSurgeIncentiveCreateForm } from '../actions';
import ProviderSurgeIncentiveCreateForm from './provider-surge-incentive-create-form';
import ModalWithToggleButton from './modal-with-toggle-button';

export const ProviderSurgeIncentiveCreateFormContainer = ({
  formValues,
  formErrors,
  changeField,
  submit,
  reset,
  shouldCloseModal,
  submitting
}) => (
  <ModalWithToggleButton
    onClose={reset}
    title={'Add Surge Incentive'}
    buttonProps={{
      text: 'Create Incentive',
      className: 'button surge-button'
    }}
    shouldCloseModal={shouldCloseModal}
  >
    <ProviderSurgeIncentiveCreateForm
      formValues={formValues}
      formErrors={formErrors}
      changeField={changeField}
      submit={submit}
      submitting={submitting}
    />
  </ModalWithToggleButton>
);

ProviderSurgeIncentiveCreateFormContainer.propTypes = {
  formValues: PropTypes.object.isRequired,
  formErrors: PropTypes.array.isRequired,
  changeField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  shouldCloseModal: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  formValues: state.providerSurgeIncentive.createForm.formValues,
  formErrors: state.providerSurgeIncentive.createForm.formErrors,
  shouldCloseModal: state.providerSurgeIncentive.createRequest.isSuccess,
  submitting: state.providerSurgeIncentive.createRequest.isLoading
});

const mapDispatchToProps = {
  changeField: providerSurgeIncentiveCreateForm.changeField,
  submit: providerSurgeIncentiveCreateForm.submit,
  reset: providerSurgeIncentiveCreateForm.reset
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderSurgeIncentiveCreateFormContainer);
